/*
 * @Description: （Parallel To）平行于x轴
 * @Author: Xiaohua Zhu
 * @Date: 2021-12-02 19:15:44
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-06-22 09:25:39
 */
import { Vector3 } from '@babylonjs/core/Maths/math';
import BaseLength from './baseLength';
import MeshManage from '../meshManage';
import { SKIRTINGBOARDCONFIG, DEFAULTSEALPLATEDEPTH, TOPFRAME_GROUND, FRAMEDEPTH, FRAMECATEGORY, CALLOUTMARGIN, GAP_BETWEEN_WALL_AND_CABINET, VERSION_2_2, DOUBLE_DOOR_REFIRGERATOR_DISTANCE, SINGLE_DOOR_REFIRGERATOR_DISTANCE, DEFAULTSEALPLATEWIDTH, AISLE_WIDTH, } from '../utils/kitchenConfig';
import { SidePlateSequence, BASICTYPE_ENUM, SidePlatePosition, SidePlateLocation, LengthType, SIDE_PLATE_TYPE, BASICRENDER_TYPE, } from '../utils/enum';
import Wall from '../room/wall';
import WindowNode from '../room/window';
import { getFramePositionInfo, isHighCabinet } from '../utils/templatejsonUtils';
import { checkFrameIsHighFrame, getCornerCabinetFrameXZ, getDefaultDoor, } from '../utils/renderUtils';
import RenderVersion from '../utils/renderVersion';
import { getNewSinkHoleInfo, getOldP2XSinkHoleInfo } from '../utils/renderSinkUtils';
class LengthP2X extends BaseLength {
    static checkTopNoFrames(templateJson, type) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const frameLength = (_c = (_b = (_a = templateJson[type]) === null || _a === void 0 ? void 0 : _a.length3) === null || _b === void 0 ? void 0 : _b.frames) === null || _c === void 0 ? void 0 : _c.length;
        if (frameLength <= 2) {
            if (frameLength === 1) {
                const frame = (_e = (_d = templateJson[type]) === null || _d === void 0 ? void 0 : _d.length3) === null || _e === void 0 ? void 0 : _e.frames[frameLength - 1];
                if (checkFrameIsHighFrame(frame)) {
                    return true;
                }
            }
            if (frameLength === 2) {
                const lasetframe = (_g = (_f = templateJson[type]) === null || _f === void 0 ? void 0 : _f.length3) === null || _g === void 0 ? void 0 : _g.frames[frameLength - 1];
                const firtframe = (_j = (_h = templateJson[type]) === null || _h === void 0 ? void 0 : _h.length3) === null || _j === void 0 ? void 0 : _j.frames[frameLength - 2];
                if (checkFrameIsHighFrame(firtframe) && checkFrameIsHighFrame(lasetframe)) {
                    return true;
                }
            }
            return false;
        }
        return false;
    }
    /**
     * @param templateJson
     * @description 判断是否是特殊U型柜
     * @returns true : 是特殊U型  false : 不是特殊U型
     */
    static checkIsSpecialUType(templateJson, type = BASICTYPE_ENUM.bottom) {
        var _a;
        const specilaType = (_a = templateJson[type]) === null || _a === void 0 ? void 0 : _a.type;
        if (specilaType === BASICRENDER_TYPE.U_S) {
            return true;
        }
        return false;
    }
    /**
       * @description: 渲染最左侧模型的侧板
       * @param {firstFrame} 传入frames数组第一个frame
       * @return {*}
       * @author: Xiaohua Zhu
       */
    // 通过传入frame来确定侧板需要摆放的基准点再向左移动位置
    renderSidePlate(frameJson, sidePlatesArr, sequence, position) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.sidePlatesArray = sidePlatesArr;
        this.initSidePlatesAndFrames(frameJson, sequence);
        const { sidePlateMeshSize, frameMeshSize, frameCenterPoint, sidePlate, sidePlateID, } = this;
        const { x: sidePlateSizeX, z: sidePlateSizeZ, y: sidePlateSizeY } = sidePlateMeshSize;
        const { x: frameSizeX, z: frameSizeZ, y: frameSizeY } = frameMeshSize;
        const { x: centerPointX, y: centerPointY, z: centerPointZ } = frameCenterPoint;
        const rotation = { x: 0, y: 0, z: 0 };
        const sidePlateScaling = frameSizeZ / sidePlateSizeX;
        if (sequence === SidePlateSequence.First && sidePlate) {
            const targetPosition = {
                x: centerPointX + frameSizeX / 2 + (sidePlateSizeZ * sidePlateScaling) / 2,
                y: centerPointY,
                z: centerPointZ,
            };
            if (this.templateJson.bottom.length3.frames.length === 1
                && ((_c = (_b = (_a = this.templateJson.top) === null || _a === void 0 ? void 0 : _a.length3) === null || _b === void 0 ? void 0 : _b.frames) === null || _c === void 0 ? void 0 : _c.length) === 1
                && checkFrameIsHighFrame((_e = (_d = this.templateJson.top) === null || _d === void 0 ? void 0 : _d.length3) === null || _e === void 0 ? void 0 : _e.frames[0])) {
                targetPosition.x = 0;
                if (position === SidePlatePosition.Top) {
                    sidePlate.meshManage.mesh.scaling.y = (this.templateJson.top.height * 0.01) / sidePlateSizeY;
                    targetPosition.y = centerPointY + frameSizeY - (this.templateJson.top.height * 0.01);
                }
                else {
                    sidePlate.meshManage.mesh.scaling.y = (this.templateJson.bottom.height * 0.01) / sidePlateSizeY;
                }
            }
            rotation.y = Math.PI / 2;
            sidePlate.meshManage.mesh.scaling.x = sidePlateScaling;
            sidePlate.moveToPosition(targetPosition, rotation);
        }
        if (sequence === SidePlateSequence.Last && sidePlate) {
            let sealPlateLength = 0;
            if (((_g = (_f = this.templateJson[position]) === null || _f === void 0 ? void 0 : _f.length3) === null || _g === void 0 ? void 0 : _g.sealPlate)
                && this.getSealPlatePos(this.templateJson, position)
                    >= this.templateJson[position].length3.frames.length) {
                sealPlateLength = new MeshManage(this.scene
                    .getMeshByName((_j = (_h = this.templateJson[position]) === null || _h === void 0 ? void 0 : _h.length3) === null || _j === void 0 ? void 0 : _j.sealPlate[0].id)).getModelSize().x;
            }
            const targetPosition = {
                x: centerPointX - frameSizeX / 2 - (sidePlateSizeZ * sidePlateScaling) / 2 - sealPlateLength,
                y: centerPointY,
                z: centerPointZ,
            };
            if (LengthP2X.checkTopNoFrames(this.templateJson, BASICTYPE_ENUM.top)) {
                targetPosition.x = centerPointX - frameSizeX / 2 - (sidePlateSizeZ * sidePlateScaling) / 2;
            }
            rotation.y = Math.PI / 2;
            sidePlate.meshManage.mesh.scaling.x = sidePlateScaling;
            sidePlate.moveToPosition(targetPosition, rotation);
        }
        if (sequence === SidePlateSequence.Corner && sidePlate) {
            let sidePlateXAfterScaling = 0;
            let sealPlateLength = 0;
            if (position === SidePlatePosition.Top) {
                sidePlate.meshManage.mesh.scaling.x = FRAMEDEPTH.TOP / sidePlateSizeX;
                sidePlateXAfterScaling = sidePlateSizeX * (FRAMEDEPTH.TOP / sidePlateSizeX);
            }
            if (position === SidePlatePosition.Bottom) {
                sidePlate.meshManage.mesh.scaling.x = FRAMEDEPTH.BOTTOM / sidePlateSizeX;
                sidePlateXAfterScaling = sidePlateSizeX * (FRAMEDEPTH.BOTTOM / sidePlateSizeX);
            }
            if (((_m = (_l = (_k = this.templateJson[position]) === null || _k === void 0 ? void 0 : _k.length3) === null || _l === void 0 ? void 0 : _l.sealPlate) === null || _m === void 0 ? void 0 : _m.length) > 0) {
                sealPlateLength = new MeshManage(this.scene
                    .getMeshByName((_p = (_o = this.templateJson[position]) === null || _o === void 0 ? void 0 : _o.length3) === null || _p === void 0 ? void 0 : _p.sealPlate[0].id)).getModelSize().x;
            }
            const targetPosition = {
                x: centerPointX - frameSizeX / 2 - sidePlateSizeZ / 2 - sealPlateLength,
                y: centerPointY,
                z: centerPointZ + (frameSizeZ - sidePlateXAfterScaling) / 2,
            };
            rotation.y = Math.PI / 2;
            sidePlate.moveToPosition(targetPosition, rotation);
        }
        return { id: sidePlateID, rotation };
    }
    getSealPlatesLength(position) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let sealPlateLength = 0;
        if (((_b = (_a = this.templateJson[position]) === null || _a === void 0 ? void 0 : _a.length3) === null || _b === void 0 ? void 0 : _b.sealPlate)
            && this.getSealPlatePos(this.templateJson, position)
                >= this.templateJson[position].length3.frames.length) {
            sealPlateLength = new MeshManage(this.scene
                .getMeshByName((_d = (_c = this.templateJson[position]) === null || _c === void 0 ? void 0 : _c.length3) === null || _d === void 0 ? void 0 : _d.sealPlate[0].id)).getModelSize().x;
        }
        if (this.templateJson.bottom.type === 'H'
            && position === SidePlatePosition.Top && ((_f = (_e = this.templateJson[position]) === null || _e === void 0 ? void 0 : _e.length3) === null || _f === void 0 ? void 0 : _f.frames.length) === 1
            && isHighCabinet((_h = (_g = this.templateJson[position]) === null || _g === void 0 ? void 0 : _g.length3) === null || _h === void 0 ? void 0 : _h.frames[0].categoryId)) {
            return 0;
        }
        return sealPlateLength;
    }
    renderSidePlateByLength(sidePlatesArr, position) {
        sidePlatesArr.forEach((sidePlateObj) => {
            if (sidePlateObj === null || sidePlateObj === void 0 ? void 0 : sidePlateObj.frameUUId) {
                /* -----------公共业务逻辑----------- */
                // 处理公共的业务 返回各自的业务所需要的 基准模型尺寸 侧板对象
                const { frameMeshSize: { x: frameSizeX, z: frameSizeZ }, sidePlate, } = this.initSidePlateConfig(sidePlateObj);
                /* -----------公共业务逻辑----------- */
                /* -----------私有数据处理----------- */
                // 侧板模型尺寸
                const { x: sidePlateSizeX, z: sidePlateSizeZ } = sidePlate.meshManage.size;
                // 侧板偏移量 基准模型长度的一半 + 侧板厚度的一半
                let basicDeviation = frameSizeX / 2 + (sidePlateSizeZ / 2);
                // 冰箱顶柜是初始化的时候所以应取反
                if (sidePlateObj.type === SIDE_PLATE_TYPE.refrigerator) {
                    basicDeviation = -basicDeviation;
                }
                // 获取该length的 补板长度 冰箱顶柜侧板不需要加上补板的长度
                const sealPlateLength = sidePlateObj.type === SIDE_PLATE_TYPE.refrigerator
                    ? 0 : this.getSealPlatesLength(position);
                /* -----------私有数据处理----------- */
                /* -----------私有业务逻辑----------- */
                // 侧板尺寸缩放至 需要贴的基准模型的面 的尺寸
                sidePlate.meshManage.mesh.scaling.x = frameSizeZ / sidePlateSizeX;
                /* -----------私有业务逻辑----------- */
                /* -----------侧板分情况的业务逻辑----------- */
                // 根据侧板的location判断 偏移量的正负
                switch (sidePlateObj.location) {
                    // First为靠近坐标轴中心点的位置
                    case SidePlateLocation.First:
                        sidePlate.lengthXSidePlateAction(basicDeviation);
                        break;
                    // Last为远离坐标轴中心点的位置
                    case SidePlateLocation.Last:
                        sidePlate.lengthXSidePlateAction(-(basicDeviation + this.getSealPlatesLength(position)));
                        // 侧板的type为1的时候是冰箱顶柜的侧板 不能用来计算冰箱的位置
                        if (sidePlateObj.type !== SIDE_PLATE_TYPE.refrigerator) {
                            this.sidePlatePositions[position].position = sidePlate.sidePosition;
                            this.sidePlatePositions[position].sideplateMesh = sidePlate;
                        }
                        else {
                            // 如果是冰箱顶柜的侧板的话 摆好位置之后将其group到cabinet上面 后面调整位置的时候一并调整
                            new MeshManage(this.scene.getMeshByName(sidePlateObj.frameUUId)).addChildModel(sidePlate.meshManage);
                        }
                        break;
                    // Corner为该侧板贴在转角柜的特殊情况
                    case SidePlateLocation.Corner:
                        sidePlate.cornerSidePlateAction(basicDeviation + sealPlateLength, position, LengthType.Length3);
                        this.sidePlatePositions[position].position = sidePlate.sidePosition;
                        this.sidePlatePositions[position].sideplateMesh = sidePlate;
                        break;
                    default:
                        break;
                }
                /* -----------侧板分情况的业务逻辑----------- */
            }
        });
    }
    // eslint-disable-next-line class-methods-use-this
    getSealPlatePos(templateJson, type) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        const frameLenghth = (_c = (_b = (_a = templateJson[type]) === null || _a === void 0 ? void 0 : _a.length3) === null || _b === void 0 ? void 0 : _b.frames) === null || _c === void 0 ? void 0 : _c.length;
        const otherLength = (_e = (_d = templateJson[type]) === null || _d === void 0 ? void 0 : _d.length3) === null || _e === void 0 ? void 0 : _e.otherSealPlateLength;
        const frameLengthP2X = (_h = (_g = (_f = templateJson[type]) === null || _f === void 0 ? void 0 : _f.length2) === null || _g === void 0 ? void 0 : _g.frames) === null || _h === void 0 ? void 0 : _h.length;
        const lastFrame = frameLenghth >= 2 ? (_k = (_j = templateJson[type]) === null || _j === void 0 ? void 0 : _j.length3) === null || _k === void 0 ? void 0 : _k.frames[frameLenghth - 1]
            : (_m = (_l = templateJson[type]) === null || _l === void 0 ? void 0 : _l.length2) === null || _m === void 0 ? void 0 : _m.frames[frameLengthP2X - 1];
        const firstFrame = frameLenghth >= 2 ? (_p = (_o = templateJson[type]) === null || _o === void 0 ? void 0 : _o.length3) === null || _p === void 0 ? void 0 : _p.frames[0] : null;
        const lastPreFrame = frameLenghth >= 2 ? (_r = (_q = templateJson[type]) === null || _q === void 0 ? void 0 : _q.length3) === null || _r === void 0 ? void 0 : _r.frames[frameLenghth - 2]
            : null;
        // 是否是 I 型
        const isIType = (_t = (_s = templateJson[type]) === null || _s === void 0 ? void 0 : _s.length2) === null || _t === void 0 ? void 0 : _t.length;
        // 没有柜体 返回null 补板在length2最后一个柜体上 U型
        if (!frameLenghth) {
            return null;
        }
        // debugger;
        // 柜体个数是否为1 可能为 I 和 U
        if (frameLenghth === 1) {
            // 特殊U型柜（没有高柜），补板位置
            if (LengthP2X.checkIsSpecialUType(this.templateJson)) {
                return 1;
            }
            // 最后一个是高柜或者转角柜，返回 null
            if (checkFrameIsHighFrame(lastFrame)) {
                return null;
            }
            // 最后一个是普通柜
            if (otherLength) {
                return frameLenghth;
            }
            // I 型判断
            if (!isIType) {
                return 1;
            }
            return null;
        }
        // otherSealPlateLength是否存在 并且柜体个数大于1 加了冰箱/高柜后补板可能会没有值， 补板只会在最后一个普通柜前面
        if (otherLength && ((_v = (_u = templateJson[type]) === null || _u === void 0 ? void 0 : _u.length3) === null || _v === void 0 ? void 0 : _v.sealPlate)) {
            // 最后一个是高柜，返回倒数第二
            if (checkFrameIsHighFrame(lastFrame)) {
                // 是否是双高柜
                if (lastPreFrame && checkFrameIsHighFrame(lastPreFrame)) {
                    return frameLenghth - 2;
                }
                return frameLenghth - 1;
            }
            // 没有高柜，但是有otherLength，补板只会在最后一个普通柜前面
            if (frameLenghth > 1) {
                return frameLenghth;
            }
            // II 型判断
            if (!isIType) {
                return 1;
            }
            // 特殊U型柜（没有高柜），补板位置
            if (LengthP2X.checkIsSpecialUType(this.templateJson)) {
                return 1;
            }
            // 最后一个是高柜，返回第一个（加冰箱可能也会有otherLength）
            return null;
        }
        // U/H型 判断 H型底柜至少有一个柜子
        if (frameLenghth > 1 && ((_x = (_w = templateJson[type]) === null || _w === void 0 ? void 0 : _w.length3) === null || _x === void 0 ? void 0 : _x.sealPlate)) {
            // 特殊U型柜（没有高柜），补板位置
            if (LengthP2X.checkIsSpecialUType(this.templateJson)) {
                return 1;
            }
            // 判断是否是 U 型（length2存在数据）
            if (isIType) {
                return null;
            }
            // 二字型 顶柜是两个高柜
            if (checkFrameIsHighFrame(lastFrame) && checkFrameIsHighFrame(firstFrame)) {
                return null;
            }
            // 二字型 默认摆放在第一个柜体后面
            return 1;
        }
        // 默认返回没有柜体
        return null;
    }
    /**
     *
     * @param frame 补板前一个柜体
     * @param lengthType top | bottom
     * @description 计算高低水槽影响的补板缩放尺寸
     * @returns 补板缩放的模型尺寸
     */
    zoomSealPlateY(frame, lengthType) {
        var _a, _b, _c, _d, _e;
        const { componentBasic: { id } } = frame;
        let defaluFrameData = new MeshManage(this.scene.getMeshByName(id));
        // 补板位置
        const sealPlatePos = this.getSealPlatePos(this.templateJson, lengthType);
        // 1.补板位置在第一个柜子前面 2. length2没有柜体
        if (sealPlatePos !== null || ((_c = (_b = (_a = this.templateJson) === null || _a === void 0 ? void 0 : _a.bottom) === null || _b === void 0 ? void 0 : _b.length3) === null || _c === void 0 ? void 0 : _c.frames.length) === 0) {
            return defaluFrameData.getModelSize().y;
        }
        // 改为以length3柜体为缩放
        const scaleYframe = (_e = (_d = this.templateJson) === null || _d === void 0 ? void 0 : _d.bottom) === null || _e === void 0 ? void 0 : _e.length3.frames[0];
        if (!checkFrameIsHighFrame(scaleYframe)) {
            defaluFrameData = new MeshManage(this.scene.getMeshByName(scaleYframe === null || scaleYframe === void 0 ? void 0 : scaleYframe.componentBasic.id));
        }
        return defaluFrameData.getModelSize().y;
    }
    renderSealPlate(sealPlateData, preMeshManage, type, frameData, addMesh) {
        var _a, _b, _c;
        if (!sealPlateData.length) {
            return null;
        }
        let sealPlateMesh;
        this.sealPlateData = sealPlateData; // 记录补板数据
        const { componentBasic } = frameData;
        let scaleX = 1;
        let scaleY = 1;
        let scaleZ = 1;
        let nextMeshManage = null;
        // 获取柜体门板的厚度
        const defalutDoor = getDefaultDoor(this.templateJson, 'length3', type);
        const defalutDoorMesh = new MeshManage(this.scene.getMeshByName((_a = defalutDoor === null || defalutDoor === void 0 ? void 0 : defalutDoor.componentBasic) === null || _a === void 0 ? void 0 : _a.id));
        const drawerDoorDeepSize = ((_b = defalutDoorMesh === null || defalutDoorMesh === void 0 ? void 0 : defalutDoorMesh.getModelSize()) === null || _b === void 0 ? void 0 : _b.z) || DEFAULTSEALPLATEDEPTH;
        const defaluFrameData = new MeshManage(this.scene.getMeshByName(componentBasic.id));
        this.initSealPlate(sealPlateData, addMesh);
        switch (type) {
            case BASICTYPE_ENUM.top:
                this.sealPlateData = sealPlateData; // 记录补板数据
                sealPlateMesh = new MeshManage(this.scene.getMeshByName(sealPlateData[0].id));
                sealPlateData.forEach((plate, plateInx) => {
                    var _a, _b, _c;
                    sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                    if (!(sealPlateMesh === null || sealPlateMesh === void 0 ? void 0 : sealPlateMesh.mesh)) {
                        sealPlateMesh = preMeshManage;
                        return;
                    }
                    switch (plateInx) {
                        case 0:
                            // 缩放
                            scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = FRAMEDEPTH.TOP / sealPlateMesh.getModelSize().y;
                            (_a = this.sealPlate) === null || _a === void 0 ? void 0 : _a.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            // 缩放后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            // 旋转
                            this.setMeshRotate(new Vector3(Math.PI / 2, 0, 0), sealPlateMesh);
                            // 旋转后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            sealPlateMesh.setModelPosition({
                                x: preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5
                                    - sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(this.templateJson) - sealPlateMesh.getModelSize().y * 0.5,
                                z: preMeshManage.mesh.position.z - preMeshManage.getModelSize().z * 0.5,
                            });
                            break;
                        case 1:
                            // 缩放
                            scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = defaluFrameData.getModelSize().y / sealPlateMesh.getModelSize().y;
                            scaleZ = DEFAULTSEALPLATEDEPTH / sealPlateMesh.getModelSize().z;
                            (_b = this.sealPlate) === null || _b === void 0 ? void 0 : _b.setSealPlatesScale(sealPlateMesh, scaleX, scaleY, scaleZ);
                            // 缩放后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            sealPlateMesh.setModelPosition({
                                x: preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5
                                    - sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(this.templateJson) - preMeshManage.getModelSize().y,
                                z: preMeshManage.mesh.position.z - preMeshManage.getModelSize().z * 0.5
                                    - sealPlateMesh.getModelSize().z / 2,
                            });
                            nextMeshManage = sealPlateMesh;
                            break;
                        case 2:
                            // 缩放
                            scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = FRAMEDEPTH.TOP / sealPlateMesh.getModelSize().y;
                            (_c = this.sealPlate) === null || _c === void 0 ? void 0 : _c.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            // 缩放后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            // 旋转
                            this.setMeshRotate(new Vector3(Math.PI / 2, 0, 0), sealPlateMesh);
                            // 旋转后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            sealPlateMesh.setModelPosition({
                                x: preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5
                                    - sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(this.templateJson) - preMeshManage.getModelSize().y
                                    + sealPlateMesh.getModelSize().y * 0.5,
                                z: preMeshManage.mesh.position.z - preMeshManage.getModelSize().z * 0.5,
                            });
                            break;
                        default:
                            break;
                    }
                });
                return nextMeshManage;
                break;
            case BASICTYPE_ENUM.bottom:
                // 相同补板，默认取第一块数据保存实例
                sealPlateMesh = new MeshManage(this.scene.getMeshByName(sealPlateData[0].id));
                // 缩放
                scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x;
                scaleY = this.zoomSealPlateY(frameData, type) / sealPlateMesh.getModelSize().y;
                scaleZ = drawerDoorDeepSize / sealPlateMesh.getModelSize().z;
                (_c = this.sealPlate) === null || _c === void 0 ? void 0 : _c.setSealPlatesScale(sealPlateMesh, scaleX, scaleY, scaleZ);
                // 缩放后需要重新获取尺寸信息
                sealPlateMesh = new MeshManage(this.scene.getMeshByName(sealPlateData[0].id));
                // eslint-disable-next-line no-case-declarations
                const { componentBasic: { width, depth }, longEdge } = frameData;
                // eslint-disable-next-line no-case-declarations
                const longLength = longEdge === 2 ? width : depth;
                // eslint-disable-next-line no-case-declarations
                let lastMoveZ = ((preMeshManage.getModelSize().z) / (longLength / 10)) * DEFAULTSEALPLATEWIDTH;
                lastMoveZ = (this === null || this === void 0 ? void 0 : this.templateJson.bottom.type) === 'H' ? lastMoveZ + sealPlateMesh.getModelSize().z : lastMoveZ;
                // 处理特殊U型柜判断
                lastMoveZ = LengthP2X.checkIsSpecialUType(this.templateJson)
                    ? (preMeshManage.getModelSize().z + sealPlateMesh.getModelSize().z * 0.5) : lastMoveZ;
                // eslint-disable-next-line no-case-declarations
                const moveSealZ = (this === null || this === void 0 ? void 0 : this.templateJson.bottom.type) === 'H' ? -sealPlateMesh.getModelSize().z * 0.5
                    : sealPlateMesh.getModelSize().z * 0.5;
                sealPlateMesh.setModelPosition({
                    x: preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5
                        - sealPlateMesh.getModelSize().x * 0.5,
                    y: SKIRTINGBOARDCONFIG.HEIGHT,
                    z: preMeshManage.mesh.position.z + preMeshManage.getModelSize().z * 0.5 - lastMoveZ
                        - moveSealZ,
                });
                return sealPlateMesh;
                break;
            default:
                return null;
                break;
        }
        // 获取最后一个柜体mesh
        // const { lastLenghMesh } = this.getLastMeshMaage(type, BASICLENGTHTYPE_ENUM.length3);
        // TODO 获取最后一个柜体的位置
        // const lastPos = {
        //   x: lastLenghMesh?.mesh?.position?.x,
        //   y: lastLenghMesh?.mesh?.position?.y,
        //   z: lastLenghMesh?.mesh?.position?.z,
        // };
        // 摆放
        // eslint-disable-next-line no-plusplus
        // for (let index = 0; index < sealPlateData.length; index++) {
        //   const mesh = new MeshManage(this.scene.getMeshByName(sealPlateData[index].id));
        //   const moveZ = index === 0
        //     ? lastLenghMesh.getModelSize().z * 0.5
        //     : -lastLenghMesh.getModelSize().z * 0.5;
        //   mesh.setModelPosition({
        //     x: lastPos.x - lastLenghMesh.getModelSize().x * 0.5 - mesh.getModelSize().x * 0.5,
        //     y: lastPos.y,
        //     z: lastPos.z + moveZ,
        //   });
        // }
    }
    /**
       * 获取水槽挖孔的相关定位及尺寸
       * @param sinkCabinetId 水槽所在柜子的ID
       * @param sinkId 水槽id
       * @param topPanelPositionY 台面的高度 需要确定洞在Y轴上面的方向
       * @returns 洞的定位跟尺寸
       */
    getSinkHolePosition(sinkCabinetId, sinkId, topPanelPositionY, cornerCabinetDirection, sinkInfo) {
        var _a;
        const sinkMesh = this.scene.getMeshByName(sinkId); // 定义水槽模型
        const sinkFrameMesh = this.scene.getMeshByName(sinkCabinetId); // 定义水槽所在柜子的整体模型
        let holePosition;
        let holeSize;
        if (RenderVersion.checkOldRenderVersion(((_a = this === null || this === void 0 ? void 0 : this.templateJson) === null || _a === void 0 ? void 0 : _a.version) || '2.1', VERSION_2_2)) {
            holePosition = getOldP2XSinkHoleInfo(sinkFrameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection).holePosition;
            holeSize = getOldP2XSinkHoleInfo(sinkFrameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection).holeSize;
        }
        else {
            holePosition = getNewSinkHoleInfo(sinkFrameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection, sinkInfo, 'p2x').holePosition;
            holeSize = getNewSinkHoleInfo(sinkFrameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection, sinkInfo, 'p2x').holeSize;
        }
        return { holePosition, holeSize };
    }
    // 获取边长
    getSideLength(minimum = 0) {
        const { lastFrame, location } = this.getLastFrame();
        let length;
        if (lastFrame) {
            const meshManage = new MeshManage(this.scene.getMeshByName(lastFrame.componentBasic.id));
            length = meshManage.getModelSize().x / 2 + Math.abs(meshManage.mesh.position.x) + this.getRLength();
        }
        else {
            length = this.templateJson[location][this.lengthType].length * 0.01;
        }
        if ((lastFrame === null || lastFrame === void 0 ? void 0 : lastFrame.categoryId) === FRAMECATEGORY.CATEGORY_39) {
            if ((lastFrame === null || lastFrame === void 0 ? void 0 : lastFrame.width) === 100) {
                length += DOUBLE_DOOR_REFIRGERATOR_DISTANCE;
            }
            else {
                length += SINGLE_DOOR_REFIRGERATOR_DISTANCE;
            }
        }
        return Math.max(length, minimum);
    }
    /**
     * @description: 建墙
     * @param {number} toLengthXDistance 距离lengthx多少距离
     * @return {*}
     * @author: Yongchao Wang
     */
    createWall(width, toLengthXDistance) {
        const wallNode = new Wall(this.scene);
        const sideLength = width !== null && width !== void 0 ? width : this.getSideLength();
        const fromPoint = { x: 0, y: 0, z: -2 * GAP_BETWEEN_WALL_AND_CABINET };
        const toPoint = { x: -sideLength, y: 0, z: -2 * GAP_BETWEEN_WALL_AND_CABINET };
        const wallSegmentNode = {
            toPoint,
            fromPoint,
            wallHeight: TOPFRAME_GROUND(this.templateJson),
            name: 'lengthP2X',
        };
        wallNode.createWall(wallSegmentNode, { x: 0, y: -Math.PI, z: 0 }, { x: -sideLength, y: 0, z: toLengthXDistance });
        this.wallNode = wallNode;
    }
    createWindow(frame, window) {
        var _a, _b;
        if (!frame || !window.componentBasic.modelUrl) {
            return;
        }
        const windowNode = new WindowNode(this.scene, this.templateJson);
        const { depth } = frame.componentBasic;
        const { width: windowWidth, height: windowHeight } = window.componentBasic;
        const frameMeshManage = new MeshManage(this.scene.getMeshByName(frame.componentBasic.id));
        // const size = frameMeshManage.getModelSize();
        const { position } = frameMeshManage.mesh;
        let windowPosition = position;
        // 判断柜体是不是带水槽的转角柜  如果是带水槽的转角柜位置根据水槽的中心点来判断
        if (frame.categoryId === FRAMECATEGORY.CATEGORY_27) {
            const { cornerCabinetDirection } = getFramePositionInfo(this.templateJson, 'sink');
            const sinkMesh = new MeshManage(this.scene.getMeshByName(((_b = (_a = frame.sink) === null || _a === void 0 ? void 0 : _a.componentBasic) === null || _b === void 0 ? void 0 : _b.id) || ''));
            windowPosition = getCornerCabinetFrameXZ(position, frameMeshManage.getModelSize(), sinkMesh.getModelSize(), cornerCabinetDirection, `length${frame.longEdge}`, 'ventilator');
        }
        const windowSegmentNode = {
            width: windowWidth / 1000,
            height: windowHeight / 1000,
            name: 'lengthP2XWindow',
            position: {
                x: windowPosition.x,
                y: TOPFRAME_GROUND(this.templateJson) - windowHeight / 1000 / 2,
                z: position.z + depth / 2 / 1000 - 0.01 + GAP_BETWEEN_WALL_AND_CABINET,
            },
            textureImage: window.componentBasic.modelUrl,
        };
        windowNode.createWindow(windowSegmentNode, { x: 0, y: 0, z: 0 });
        this.windowNode = windowNode;
    }
    getFramesCalloutLine(position, title) {
        var _a, _b, _c;
        const topToGround = this.getCalloutLineTopToGround(position);
        const { length, lengthValue } = this.getLengthByAddAllFrames(position);
        const { startHeight, endHeight } = this.getCalloutLineHeightLength();
        const calloutLineDepthLength = this.getCalloutLineDepthLength();
        const l2Length = ((_c = (_b = (_a = this.templateJson) === null || _a === void 0 ? void 0 : _a.bottom) === null || _b === void 0 ? void 0 : _b.length2) === null || _c === void 0 ? void 0 : _c.length) / 100 || AISLE_WIDTH + FRAMEDEPTH.BOTTOM * 2;
        /* -----------长度标线----------- */
        const startPoint = { x: 0, y: topToGround + CALLOUTMARGIN, z: l2Length };
        const endPoint = { x: -length, y: topToGround + CALLOUTMARGIN, z: l2Length };
        const lengthLine = { startPoint, endPoint };
        /* -----------长度标线----------- */
        /* -----------高度标线1----------- */
        // 长度标线起点的高度标线起点
        const startHeightStartPoint = {
            x: startPoint.x + CALLOUTMARGIN,
            y: this.getCalloutLineHeightHeight(),
            z: startPoint.z,
        };
        // 长度标线起点的高度标线终点
        const startHeightEndPoint = {
            x: startHeightStartPoint.x,
            y: startHeightStartPoint.y + startHeight,
            z: startHeightStartPoint.z,
        };
        // 长度标线起点的高度标线
        const startHeightLine = {
            startPoint: startHeightStartPoint,
            endPoint: startHeightEndPoint,
        };
        /* -----------高度标线1----------- */
        /* -----------高度标线2----------- */
        // 长度标线终点的高度标线起点
        const endHeightStartPoint = {
            x: endPoint.x - CALLOUTMARGIN,
            y: this.getCalloutLineHeightHeight(),
            z: endPoint.z,
        };
        // 长度标线终点的高度标线终点
        const endHeightEndPoint = {
            x: endHeightStartPoint.x,
            y: endHeightStartPoint.y + endHeight,
            z: endHeightStartPoint.z,
        };
        // 长度标线终点的高度标线
        const endHeightLine = {
            startPoint: endHeightStartPoint,
            endPoint: endHeightEndPoint,
        };
        /* -----------高度标线2----------- */
        /* -----------深度标线1----------- */
        // 长度标线起点的深度标线起点（长度标线起点的高度标线起点）
        const startDepthStartPoint = startHeightStartPoint;
        // 长度标线终点的深度标线起点
        const startDepthEndPoint = {
            x: startDepthStartPoint.x,
            y: startDepthStartPoint.y,
            z: startDepthStartPoint.z - calloutLineDepthLength,
        };
        // 长度标线终点的深度标线
        const startDepthLine = {
            startPoint: startDepthStartPoint,
            endPoint: startDepthEndPoint,
        };
        /* -----------深度标线2----------- */
        /* -----------深度标线2----------- */
        // 长度标线终点的深度标线起点（长度标线终点的高度标线起点）
        const endDepthStartPoint = endHeightStartPoint;
        // 长度标线终点的深度标线起点
        const endDepthEndPoint = {
            x: endDepthStartPoint.x,
            y: endDepthStartPoint.y,
            z: endDepthStartPoint.z - calloutLineDepthLength,
        };
        // 长度标线终点的深度标线
        const endDepthLine = {
            startPoint: endDepthStartPoint,
            endPoint: endDepthEndPoint,
        };
        /* -----------深度标线2----------- */
        const calloutLinesArr = [];
        calloutLinesArr.push({
            type: 'length', line: lengthLine, value: lengthValue, title: title || 'L3',
        });
        calloutLinesArr.push({
            type: 'startHeight', line: startHeightLine, value: startHeight, isHeight: true,
        });
        calloutLinesArr.push({
            type: 'endHeight', line: endHeightLine, value: endHeight, isHeight: true,
        });
        calloutLinesArr.push({
            type: 'startDepth', line: startDepthLine, value: calloutLineDepthLength,
        });
        calloutLinesArr.push({
            type: 'endDepth', line: endDepthLine, value: calloutLineDepthLength,
        });
        return calloutLinesArr;
    }
}
export default LengthP2X;
